import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const UploadButtonStyled = styled.div(({ theme, size, disabled }) => {
  const styleSheet = {
    cursor: 'pointer',
    background: theme.color.wfGrey200,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 24,
    height: 24,
    borderRadius: 100,
  };

  if (size === 'medium') {
    styleSheet.width = 32;
    styleSheet.height = 32;
  }

  if (disabled) {
    styleSheet.cursor = 'default';
    styleSheet.color = theme.color.wfGrey500;
  } else {
    styleSheet['&:hover'] = {
      color: theme.color.wfBlack,
      // background: theme.color.wfGrey300,
    };
  }

  return styleSheet;
});

const UploadButton = ({ onClick, size, children, disabled }) => {
  const handleClick = () => {
    if (disabled) return;
    onClick?.();
  };
  return (
    <UploadButtonStyled onClick={handleClick} size={size} disabled={disabled}>
      {children}
    </UploadButtonStyled>
  );
};

UploadButton.propTypes = {
  onClick: PropTypes.func,
  size: PropTypes.string,
  children: PropTypes.node,
  disabled: PropTypes.bool,
};

export default observer(UploadButton);
